import { push } from 'react-router-redux';
import { path } from 'ramda';
import { isBarberUser } from '../../auth/selectors';

export const redirectTo = url => (dispatch, getState) => {
  const search = path(['routing', 'locationBeforeTransitions', 'search'], getState());
  return dispatch(push({ pathname: url, search }));
};

export const roleAwareRedirect = url => (dispatch, getState) => {
  const isBarber = isBarberUser(getState());
  return dispatch(redirectTo(`${isBarber ? '/barber' : ''}${url}`));
};
